import { render, staticRenderFns } from "./centerLeftage.vue?vue&type=template&id=3bc84608&scoped=true&"
import script from "./centerLeftage.vue?vue&type=script&lang=js&"
export * from "./centerLeftage.vue?vue&type=script&lang=js&"
import style0 from "./centerLeftage.vue?vue&type=style&index=0&id=3bc84608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc84608",
  null
  
)

export default component.exports